export default __webpack_public_path__ + "static/media/sr.1f659d68.png";